<template>
    <div>
       <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                        <div class="h-thirdColumn w-newColumn">
                            <el-form-item label="分公司类型" prop="companyType">
                                <el-select v-model.trim="q.companyType"  placeholder="分公司类型" >
                                    <el-option label="厚宏" value="厚宏"></el-option>
                                    <el-option label="元析" value="元析"></el-option>
                                </el-select>
                             </el-form-item>

                            <el-form-item label="省">
                                <el-select v-model.trim="q.province"
                                           placeholder="省" style="width: 68%;" :clearable="true">
                                    <el-option
                                        v-for="item in shenglist"
                                        :key="item.name"
                                        :label="item.name"
                                        :value="item.name">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="负责人">
                                <el-input clearable v-model="q.userCodeNameLike"></el-input>
                            </el-form-item>

                        </div>
                        <div class="h-formBtnOut h-columnCenter">
                            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
                                       @click="createdict">新建负责人</el-button>
                        </div>
                    </el-form>
                </div>
            </div>
            <div class="h-table h-mrt30">
                <el-table
                        @selection-change="handleSelectionChange"
                        ref="ddtable"
                        :data="tableData"
                        stripe
                        border
                        style="width: 100%"
                >
                    <el-table-column
                            type="selection"
                            width="40"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="companyType"
                        label="分公司类型"
                        width="100"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="sceneType"
                        label="场景类型"
                        width="100"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>

                    <el-table-column
                        prop="province"
                        label="省"
                        width="100"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>

                    <el-table-column
                        prop="userCode"
                        label="负责人工号"
                        width="120"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="userName"
                            label="负责人名称"
                            width="120"
                    >
                    </el-table-column>

                    <el-table-column
                        prop="phone"
                        label="联系电话"
                        width="100"
                    >
                    </el-table-column>

                    <el-table-column
                        prop="cuname"
                        label="创建人"
                        width="120"
                    >
                    </el-table-column>

                    <el-table-column
                            prop="cdate"
                            label="创建时间"
                            width="120"
                    >
                    </el-table-column>

                    <el-table-column
                            prop="lucode"
                            label="修改人"
                            width="120"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="ldate"
                            label="修改时间"
                            width="120"
                    >
                    </el-table-column>

                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="160"
                    >
                        <template slot-scope="scope">
                            <el-button
                                    class="h-tableLink h-btn"
                                    @click="handleEdit(scope.row)">修改</el-button>
                            <el-button
                                    class="h-tableLink h-btn"
                                    @click="handleDelete(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>

                </el-table>
                <div class="h-tableBL" style="margin:20px 0 0 20px;display:flex;justify-content:space-between">
                    <div>
                        <el-button
                                class="h-btn h-formBtn h-bgblueQ"
                                icon="h-el-icon h-el-icon-import"
                                style="margin-left:-20px;"
                                @click="exportExcel" >
                            批量导出
                        </el-button>

                    </div>
                    <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                        <pagination :page="q" @query="query"/>
                    </div>
                </div>
            </div>

            <div>
                <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="h-dialog2">
                    <div class="h-dialogImg">
                        <div class="h-disTable">
                            <div class="h-tableCell">
                                <h1>修改（新建）负责人</h1>
                            </div>
                        </div>
                    </div>
                    <div class="h-formLine">
                        <el-form ref="form" :model="f"
                                 :inline="true"  class="demo-ruleForm h-formbLine h-dialogForm">


                            <el-form-item label="分公司类型" prop="companyType" :rules="[
                              { required: true, message: '请选择分公司类型', trigger: 'blur'}]" class="h-elformWrap-2">
                                <el-select v-model.trim="f.companyType"
                                           placeholder="分公司类型" >
                                    <el-option label="厚宏" value="厚宏"></el-option>
                                    <el-option label="元析" value="元析"></el-option>
                                </el-select>
                            </el-form-item>


                            <el-form-item v-if="f.companyType=='厚宏'" label="场景类型" prop="sceneType" :rules="[
                              { required: true, message: '请选择场景类型', trigger: 'blur'}]" class="h-elformWrap-2">
                                <el-select v-model.trim="f.sceneType"   placeholder="场景类型"  >
                                    <el-option label="药房&静配方案" value="药房&静配方案"></el-option>
                                    <el-option label="手术室场景方案" value="手术室场景方案"></el-option>
                                </el-select>
                            </el-form-item>


                            <el-form-item label="省" prop="provinceArray" :rules="[
                              { required: true, message: '请选择省', trigger: 'blur'}]" class="h-elformWrap-2">
                                <el-select v-model.trim="f.provinceArray"
                                           :multiple="true"
                                           placeholder="省"
                                           :clearable="true">
                                    <el-option  label="全国"  value="全国">  </el-option>
                                    <el-option
                                        v-for="item in shenglist"
                                        :key="item.code"
                                        :label="item.name"
                                        :value="item.name">
                                    </el-option>
                                </el-select>
                            </el-form-item>


                            <el-form-item label="负责人工号" prop="userCode" :rules="[
                                          { required: true, message: '请输负责人工号', trigger: 'blur'},
                                        ]" class="h-elformWrap-2">
                                <el-input v-model.trim="f.userCode" @change="checkUser"></el-input>
                            </el-form-item>

                            <el-form-item label="负责人名称" prop="userName" :rules="[
                                          { required: true, message: '请输负责人名称', trigger: 'blur'},
                                        ]" class="h-elformWrap-2">
                                <el-input v-model.trim="f.userName"></el-input>
                            </el-form-item>

                            <el-form-item label="手机号码" prop="phone" :rules="[
                                          { required: true, message: '请输入手机号码', trigger: 'blur'},
                                          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
                                        ]" class="h-elformWrap-2">
                                <el-input v-model.trim="f.phone"></el-input>
                            </el-form-item>


                            <el-form-item label="备注" prop="remark"  class="h-elformWrap-2">
                                <el-input v-model.trim="f.remark"></el-input>
                            </el-form-item>


                        </el-form>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="closeM">取 消</el-button>
                        <el-button class="h-btn h-formBtn h-bgblue2" @click="saveOrUpdate">提交保存</el-button>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>
<script>

    import ss from "@/api/SystemService";
    import updownfile from '../../../utils/updownfile'
    export default {
        components: {

        },
        data() {

            return {
                uploaddownexcelflag: false,

                showYonghuflag: false,
                //table列表
                tableData: [],
                shenglist: [],
                //查询属性
                q: {
                    companyType:null,
                    province:null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                //表单
                f:{
                    id:null,
                    companyType:null,
                    province:null,
                    provinceArray:[],
                    sceneType:null,
                    userCode:null,
                    userName:null,
                    phone:null,
                    remark:null,


                },
                optflag:'save',
                //弹出框
                dialogFormVisible: false,
                //表格
                multipleSelection: [],
            }
        },
        created() {
            this.query();
            this.loadArea();
        },
        methods: {

            //检查用户是否存在
            checkUser(code){
                ss.UserService.selectById(code).then(rd => {
                    if(rd.obj==null){
                        this.$msg.msge("该人员在系统中不存在！");
                        this.f.userCode ='';
                        this.f.userCode ='';
                    }else{
                        this.f.userName = rd.obj.username;
                    }
                })
            },

            loadArea() {
                let proSelect = {
                    pcode: 0,
                    level: 1,
                }
                ss.Dictservice.arealist(proSelect).then(rd => {
                    this.shenglist = rd;
                })
            },

            query() {
                ss.clueOwner.companySelectPage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                })
            },

            handleFilter() {
                this.query();

            },
            createdict(){

                this.f={
                    id:null,
                    companyType:null,
                    province:null,
                    provinceArray:[],
                    sceneType:null,
                    userCode:null,
                    userName:null,
                    phone:null,
                    remark:null,
                },
                this.dialogFormVisible = true;
                this.optflag = 'save'
            },
            handleEdit(obj){
                //设置提交的字段
                this.f = {
                    ...obj,
                    provinceArray: []
                };

                if(obj.province){
                    this.f.provinceArray = obj.province.split('、').map(item => item.trim());
                }

                this.dialogFormVisible = true;
                this.optflag = 'update'

            },
            handleDelete(obj){
                this.$msg.confirm("确认删除?",()=>{
                    ss.clueOwner.companyDeleteById({id:obj.id}).then(rd=>{
                        this.$msg.msgs("删除成功！");
                        this.query();
                    });
                })
            },
            //保存数据字典
            saveOrUpdate(){

                this.$refs['form'].validate((valid) => {

                    if (valid) {
                        //将数组转为字符串
                        if(this.f.provinceArray){
                            this.f.province = this.f.provinceArray.join('、')
                            this.f.provinceArray = null;
                        }
                        var retobj = null;
                        if(this.optflag == 'save'){
                            retobj = ss.clueOwner.companyInsert(this.f);
                        }else if(this.optflag =="update"){
                            retobj = ss.clueOwner.companyUpdateById(this.f);
                        }
                        retobj.then(rd=>{
                            this.dialogFormVisible = false;
                            this.$msg.msgs("操作成功！");

                            this.query();
                        });
                    } else {
                        return false;
                    }
                });
            },
            //关闭
            closeM(){
                this.dialogFormVisible = false;
            },


            //选中
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            //明细导出
            exportExcel() {
                var idlist = [];
                this.multipleSelection.forEach(element => {
                    idlist.push(element.id);
                });
                updownfile.down("/api/swyl/v1/demo/bscClueCompanyOwner/downloadExcel", idlist, "get", 'data');
            },
            //导入Excel
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            uploadExcelFilecallback(rd) {
                this.query();
                this.$msg.msgs(rd.msg);
            },
        }
    }
</script>
